import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "py-4" }
const _hoisted_2 = {
  key: 0,
  class: "row mb-4"
}
const _hoisted_3 = { class: "col-md-3" }
const _hoisted_4 = { class: "card bg-light" }
const _hoisted_5 = { class: "card-body text-center" }
const _hoisted_6 = { class: "card-title text-muted" }
const _hoisted_7 = { class: "mb-0" }
const _hoisted_8 = { class: "col-md-3" }
const _hoisted_9 = { class: "card bg-success text-white" }
const _hoisted_10 = { class: "card-body text-center" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, "已发放", -1)
const _hoisted_12 = { class: "mb-0" }
const _hoisted_13 = { class: "col-md-3" }
const _hoisted_14 = { class: "card bg-warning text-white" }
const _hoisted_15 = { class: "card-body text-center" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, "待处理", -1)
const _hoisted_17 = { class: "mb-0" }
const _hoisted_18 = { class: "col-md-3" }
const _hoisted_19 = { class: "card bg-danger text-white" }
const _hoisted_20 = { class: "card-body text-center" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, "发放失败", -1)
const _hoisted_22 = { class: "mb-0" }
const _hoisted_23 = { class: "card-header card-header-stretch" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_25 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_26 = { class: "mb-3" }
const _hoisted_27 = /*#__PURE__*/_createTextVNode("手动发放奖励")
const _hoisted_28 = /*#__PURE__*/_createTextVNode("重试所有失败")
const _hoisted_29 = {
  class: "text-muted",
  style: {"font-size":"12px"}
}
const _hoisted_30 = {
  class: "text-muted",
  style: {"font-size":"12px"}
}
const _hoisted_31 = {
  key: 0,
  class: "text-muted",
  style: {"font-size":"12px"}
}
const _hoisted_32 = /*#__PURE__*/_createTextVNode("商品")
const _hoisted_33 = /*#__PURE__*/_createTextVNode("优惠券")
const _hoisted_34 = {
  key: 0,
  class: "text-danger",
  style: {"font-size":"12px"}
}
const _hoisted_35 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" 重试 ")
const _hoisted_37 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", {
  class: "text-muted",
  style: {"font-size":"12px"}
}, "强制模式会删除该日期的失败/待处理记录后重新发放", -1)
const _hoisted_39 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_40 = /*#__PURE__*/_createTextVNode("确定发放")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_vxe_form_item = _resolveComponent("vxe-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_vxe_input = _resolveComponent("vxe-input")!
  const _component_vxe_button = _resolveComponent("vxe-button")!
  const _component_vxe_form = _resolveComponent("vxe-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_vxe_column = _resolveComponent("vxe-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_vxe_table = _resolveComponent("vxe-table")!
  const _component_vxe_pager = _resolveComponent("vxe-pager")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.stats.date)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("h5", _hoisted_6, _toDisplayString(_ctx.stats.date) + " 发放总数", 1),
                _createElementVNode("h2", _hoisted_7, _toDisplayString(_ctx.stats.total), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("h2", _hoisted_12, _toDisplayString(_ctx.stats.by_status?.delivered || 0), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("h2", _hoisted_17, _toDisplayString(_ctx.stats.by_status?.pending || 0), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _createElementVNode("h2", _hoisted_22, _toDisplayString(_ctx.stats.by_status?.failed || 0), 1)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_23, [
      _createVNode(_component_vxe_form, {
        data: _ctx.formData,
        onSubmit: _ctx.submitEvent
      }, {
        default: _withCtx(() => [
          _createVNode(_component_vxe_form_item, {
            field: "reward_date",
            "item-render": {}
          }, {
            default: _withCtx(({}) => [
              _createVNode(_component_el_date_picker, {
                modelValue: _ctx.formData.reward_date,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.reward_date) = $event)),
                type: "date",
                placeholder: "奖励日期",
                "value-format": "YYYY-MM-DD",
                clearable: ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_vxe_form_item, {
            field: "status",
            "item-render": {}
          }, {
            default: _withCtx(({}) => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.formData.status,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.status) = $event)),
                placeholder: "发放状态",
                clearable: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: "全部",
                    value: ""
                  }),
                  _createVNode(_component_el_option, {
                    label: "待处理",
                    value: "pending"
                  }),
                  _createVNode(_component_el_option, {
                    label: "已发放",
                    value: "delivered"
                  }),
                  _createVNode(_component_el_option, {
                    label: "失败",
                    value: "failed"
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_vxe_form_item, {
            field: "item_type",
            "item-render": {}
          }, {
            default: _withCtx(({}) => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.formData.item_type,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.item_type) = $event)),
                placeholder: "奖励类型",
                clearable: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: "全部",
                    value: ""
                  }),
                  _createVNode(_component_el_option, {
                    label: "商品",
                    value: "product"
                  }),
                  _createVNode(_component_el_option, {
                    label: _ctx.pointLabel,
                    value: "point"
                  }, null, 8, ["label"]),
                  _createVNode(_component_el_option, {
                    label: "优惠券",
                    value: "coupon"
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_vxe_form_item, {
            field: "user_mobile",
            "item-render": {}
          }, {
            default: _withCtx(({}) => [
              _createVNode(_component_vxe_input, {
                modelValue: _ctx.formData.user_mobile,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.user_mobile) = $event)),
                placeholder: "用户手机号"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_vxe_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_vxe_button, {
                type: "submit",
                status: "primary"
              }, {
                default: _withCtx(() => [
                  _hoisted_24
                ]),
                _: 1
              }),
              _createVNode(_component_vxe_button, {
                type: "button",
                onClick: _ctx.onReset
              }, {
                default: _withCtx(() => [
                  _hoisted_25
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data", "onSubmit"])
    ]),
    _createElementVNode("div", _hoisted_26, [
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: _ctx.showDistributeDialog
      }, {
        default: _withCtx(() => [
          _hoisted_27
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_el_button, {
        type: "warning",
        onClick: _ctx.retryAllFailed,
        loading: _ctx.retryLoading
      }, {
        default: _withCtx(() => [
          _hoisted_28
        ]),
        _: 1
      }, 8, ["onClick", "loading"])
    ]),
    _createVNode(_component_vxe_table, {
      data: _ctx.tableData,
      "row-config": { isHover: true }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_vxe_column, {
          field: "id",
          title: "ID",
          width: "60"
        }),
        _createVNode(_component_vxe_column, {
          title: "用户",
          width: "150"
        }, {
          default: _withCtx(({ row }) => [
            _createElementVNode("div", null, _toDisplayString(row.user_nickname || '-'), 1),
            _createElementVNode("div", _hoisted_29, _toDisplayString(row.user_mobile), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          field: "reward_date",
          title: "奖励日期",
          width: "100"
        }),
        _createVNode(_component_vxe_column, {
          title: "排名/数量",
          width: "100"
        }, {
          default: _withCtx(({ row }) => [
            _createElementVNode("div", null, "第" + _toDisplayString(row.rank) + "名", 1),
            _createElementVNode("div", _hoisted_30, _toDisplayString(row.postcard_count) + "张", 1)
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          title: "奖励配置",
          width: "150"
        }, {
          default: _withCtx(({ row }) => [
            _createElementVNode("div", null, _toDisplayString(row.config_name), 1),
            (row.config_description)
              ? (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString(row.config_description), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          title: "奖励类型",
          width: "100"
        }, {
          default: _withCtx(({ row }) => [
            (row.item_type === 'product')
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 0,
                  type: "primary",
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _hoisted_32
                  ]),
                  _: 1
                }))
              : (row.item_type === 'point')
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 1,
                    type: "success",
                    size: "small"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.pointLabel), 1)
                    ]),
                    _: 1
                  }))
                : (row.item_type === 'coupon')
                  ? (_openBlock(), _createBlock(_component_el_tag, {
                      key: 2,
                      type: "warning",
                      size: "small"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_33
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          title: "奖励内容",
          width: "150"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.item_description || '-'), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          title: "状态",
          width: "100"
        }, {
          default: _withCtx(({ row }) => [
            (row.status === 'delivered')
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 0,
                  type: "success",
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(row.status_text), 1)
                  ]),
                  _: 2
                }, 1024))
              : (row.status === 'pending')
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 1,
                    type: "warning",
                    size: "small"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(row.status_text), 1)
                    ]),
                    _: 2
                  }, 1024))
                : (row.status === 'failed')
                  ? (_openBlock(), _createBlock(_component_el_tag, {
                      key: 2,
                      type: "danger",
                      size: "small"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row.status_text), 1)
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          title: "错误信息",
          width: "150"
        }, {
          default: _withCtx(({ row }) => [
            (row.error_message)
              ? (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(row.error_message), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_35, "-"))
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          field: "created_at",
          title: "创建时间",
          width: "160"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(_ctx.formatDate(row.created_at)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          title: "操作",
          width: "100",
          fixed: "right"
        }, {
          default: _withCtx(({ row }) => [
            (row.retryable)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  type: "warning",
                  size: "small",
                  onClick: ($event: any) => (_ctx.retrySingle(row)),
                  loading: row.retrying
                }, {
                  default: _withCtx(() => [
                    _hoisted_36
                  ]),
                  _: 2
                }, 1032, ["onClick", "loading"]))
              : (_openBlock(), _createElementBlock("span", _hoisted_37, "-"))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(_component_vxe_pager, {
      "current-page": _ctx.page.currentPage,
      "onUpdate:current-page": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.page.currentPage) = $event)),
      "page-size": _ctx.page.pageSize,
      "onUpdate:page-size": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.page.pageSize) = $event)),
      total: _ctx.page.totalResult,
      layouts: [
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total',
      ],
      onPageChange: _ctx.onPageChange
    }, null, 8, ["current-page", "page-size", "total", "onPageChange"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.distributeDialogVisible,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.distributeDialogVisible) = $event)),
      title: "手动发放奖励",
      width: "400px"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.distributeDialogVisible = false))
        }, {
          default: _withCtx(() => [
            _hoisted_39
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.doDistribute,
          loading: _ctx.distributeLoading
        }, {
          default: _withCtx(() => [
            _hoisted_40
          ]),
          _: 1
        }, 8, ["onClick", "loading"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, { "label-width": "100px" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "发放日期" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.distributeForm.date,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.distributeForm.date) = $event)),
                  type: "date",
                  placeholder: "选择日期",
                  "value-format": "YYYY-MM-DD"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "强制模式" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_switch, {
                  modelValue: _ctx.distributeForm.force,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.distributeForm.force) = $event))
                }, null, 8, ["modelValue"]),
                _hoisted_38
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}